module.exports = __webpack_public_path__ + "img/receipt.13a68839.svg";